import React, { memo } from 'react';
import { formGroup, formControl, FormDataType } from '@core/utils/form';
import { CBody } from '@modules/common/CBody';
import { FormColorPicker, FormSelect, FormInput, FormCheckbox } from '@core/components/form';
import { WidgetConfirmProps } from '../types';
import { CardTitle } from 'reactstrap';

export function defineBarChartWidgetConfirmForm() {
  return formGroup({
    color: formControl<string>({ label: 'Bar Color', initialValue: '#34c38f' }),
    layout: formControl<string>({ label: 'Layout', initialValue: 'vertical' }),
    naValue: formControl<string>({ label: 'N/A Label' }),
    showValuesOnGraph: formControl<boolean>({ label: 'Show values on the graph', initialValue: false }),
  });
}

export type BarChartWidgetConfigType = ReturnType<typeof defineBarChartWidgetConfirmForm>;
export type BarChartWidgetConfigData = FormDataType<typeof defineBarChartWidgetConfirmForm>;

export const BarChartWidgetConfig = memo((props: WidgetConfirmProps<BarChartWidgetConfigType, BarChartWidgetConfigData>) => {
  const { form, data } = props;
  return (
    <CBody>
      <CardTitle>Widget UI Settings</CardTitle>
      <FormColorPicker control={form.controls.color} />
      <FormCheckbox control={form.controls.showValuesOnGraph} />
      <FormSelect
        type="single"
        control={form.controls.layout}
        items={[
          { label: 'Vertical', value: 'vertical' },
          { label: 'Horizontal', value: 'horizonal' },
        ]}
      />
      <FormInput control={form.controls.naValue} />
    </CBody>
  );
});
